<div class="mb-4 flex items-center justify-between gap-4">
	<div class="text-base font-bold text-black">Upload Data</div>
	<div class="flex items-center gap-3 font-medium text-grey-40">
		<span class="text-red">Pilot Data Management</span>
		<span>></span>
		<span>Upload Data</span>
	</div>
</div>

<form [formGroup]="uploadForm">
	<div class="min-h-[20vh]">
		<div class="grid grid-cols-2 gap-4">
			<!-- Staff Number -->
			<div class="form-element">
				<mat-label for="form-staffId">Staff Id</mat-label>
				<mat-form-field appearance="outline" class="form-field-responsive mt-1 w-full">
					<input
						type="text"
						formControlName="staffId"
						matInput
						class="w-full"
						placeholder="Staff Id"
						maxlength="7"
						(focusout)="onFocusOut($event)"
					/>
					<img class="absolute right-2 top-1/2 w-4 -translate-y-1/2" src="/assets/icon_search_2.svg" alt="Search" />
					@if (staffId.errors) {
						<mat-error>
							{{ sharedService.getErrorMessage(staffId) }}
						</mat-error>
					}
				</mat-form-field>
			</div>

			<!-- staff name -->
			<div class="form-element">
				<mat-label for="form-name">Name</mat-label>
				<mat-form-field appearance="outline" class="form-field-responsive mt-1 w-full">
					<input type="text" formControlName="name" matInput class="w-full" placeholder="Name" [readonly]="isOnline" />
					@if (name.errors) {
						<mat-error>
							{{ sharedService.getErrorMessage(name) }}
						</mat-error>
					}
				</mat-form-field>
			</div>

			<!-- Folder Category -->
			<div class="form-element">
				<mat-label for="form-folderCategory">Folder Category</mat-label>
				<mat-form-field appearance="outline" class="form-field-responsive mt-1 w-full">
					<mat-select formControlName="folderCategory" placeholder="Select Folder Category">
						@for (category of folderCategories; track category) {
							<mat-option [value]="category.code">{{ category.value }}</mat-option>
						}
					</mat-select>
					@if (folderCategory.errors) {
						<mat-error>
							{{ sharedService.getErrorMessage(folderCategory) }}
						</mat-error>
					}
				</mat-form-field>
			</div>

			<!-- File Selection -->
			<div class="form-element">
				<mat-label for="form-file">Select File</mat-label>
				<mat-form-field appearance="outline" class="form-field-responsive form-field mt-1 w-full">
					@if (selectedFiles.length === 0) {
						<textarea
							matInput
							formControlName="files"
							class="w-full resize-none"
							placeholder="Select File"
							[value]="selectedFilesDisplay"
							readonly
							(click)="fileInput.click()"
							[rows]="1"
						></textarea>
					} @else {
						<input
							matInput
							type="text"
							[value]="selectedFiles.length + ' file(s) selected'"
							readonly
							style="display: none"
						/>
					}

					@if (selectedFiles.length === 0) {
						<img class="absolute right-2 top-1/2 w-4 -translate-y-1/2" src="/assets/icon_search_2.svg" alt="Search" />
					}

					@if (selectedFiles.length > 0) {
						<div class="min-h-[40px] w-full p-2">
							@for (file of selectedFiles; track $index) {
								<div
									class="mb-1 flex items-center justify-between rounded border bg-gray-50 px-2 py-1 transition-colors hover:bg-gray-100"
								>
									<span class="flex-1 truncate text-sm">{{ file.name }}</span>
									<button
										type="button"
										class="ml-2 text-red-500 hover:text-red-700 focus:outline-none"
										(click)="removeFile($index)"
										title="Remove file"
									>
										<span class="aa-mat-icon text-sm">close</span>
									</button>
								</div>
							}
							<button
								type="button"
								class="flex w-full items-center justify-center rounded border-2 border-dashed border-gray-300 py-1 text-sm text-blue-600 transition-colors hover:border-blue-400 hover:text-blue-800 focus:outline-none"
								(click)="fileInput.click()"
							>
								<span class="aa-mat-icon mr-1 text-sm">add</span>
								Add More Files
							</button>
						</div>
					}

					@if (files.errors) {
						<mat-error>
							{{ sharedService.getErrorMessage(files) }}
						</mat-error>
					}
				</mat-form-field>
				<input #fileInput type="file" hidden (change)="onFileSelected($event)" [accept]="allowedFileTypes" multiple />
			</div>
		</div>
	</div>

	<!-- NAVIGATION -->
	<div class="mt-6 flex items-center justify-between gap-4 border-t border-blue-20 pt-4">
		<button (click)="goBack()" class="aa-btn" data-variant="tertiary">Cancel</button>

		<button (click)="onSubmit()" class="aa-btn" data-variant="primary">Upload</button>
	</div>
</form>
